
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.355 1.815a.498.498 0 010 .705l-.915.915L6.565 1.56 7.48.645a.498.498 0 01.705 0l1.17 1.17zM.5 9.5V7.625l5.53-5.53L7.905 3.97 2.375 9.5H.5z","fill":"#767676"}})])
          )
        }
      }
    